/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Bot_Meta_TitleInputs */

const en_bot_meta_title = /** @type {(inputs: Bot_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`BystepBot · Bystep`)
};

const id_bot_meta_title = /** @type {(inputs: Bot_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`BystepBot · Bystep`)
};

/**
* | output |
* | --- |
* | "BystepBot · Bystep" |
*
* @param {Bot_Meta_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const bot_meta_title = /** @type {((inputs?: Bot_Meta_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Bot_Meta_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_bot_meta_title(inputs)
	return en_bot_meta_title(inputs)
});